// extracted by mini-css-extract-plugin
module.exports = {"active":"CustomDataTableRow_active__2QcBf","iconTrash":"CustomDataTableRow_iconTrash__3gVFI"};